import { useLocation, useNavigate } from "react-router-dom";
import useAuthentication from "../../../hooks/useAuthentication";
import { useForm } from "react-hook-form";
import {
  initialFormData,
  MasterFormDataType,
  MasterTableDataType,
  SubDeptSearchParams,
} from "./types";
import usePopup from "../../../hooks/usePopup";
import { useMutation, useQuery } from "react-query";
import { getSecimen, saveMasterData } from "./services";
import { SyntheticEvent, useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Button,
  CircularProgress,
  Divider,
} from "@mui/material";
import { CustomFormField } from "../../../utilis/component/CustomFormElement";
import SaveIcon from "@mui/icons-material/Save";
import CloseIcon from "@mui/icons-material/Close";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { getMastersTableData } from "../SubDepartmentMasters/services";
import { getMastersTableData as cptSearch } from "../cptMaster/services";

const pageTitle = "category ";
function AddOrSubDepartment() {
  const { user } = useAuthentication();
  const navigate = useNavigate();
  const [open, setOpen] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useState<SubDeptSearchParams>({
    isActive: 1,
    searchText: "",
    // deptId: 0,
  });

  const [cptSearchParams, setCptSearchParams] = useState({
    pageNumber: 0,
    pageSize: 250,
    sortField: "",
    sortOrder: "",
    filter: {
      searchText: "",
      status: 2,
      // cptGrpId: 1,
    },
  });

  const form = useForm<MasterFormDataType>({
    defaultValues: initialFormData,
  });

  const { state: data = null } = useLocation() as {
    state: MasterTableDataType;
  };
  const { showSnackbar } = usePopup();
  const handleGoBack = () => {
    navigate(-1);
  };

  const { data: subDepartmentList, isLoading: departmentLoading } = useQuery(
    [`${pageTitle}subdepartment`, searchParams],
    async () =>
      getMastersTableData({
        ...searchParams,
        clinicId: Number(user?.clinicId),
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { data: cpts, isLoading: cptsLoading } = useQuery(
    [`${pageTitle}cpts`, cptSearchParams],
    async () =>
      cptSearch({
        ...cptSearchParams,
        codetype:String(user?.codetype)
      }),
    {
      refetchOnWindowFocus: false,
    }
  );

  const { data: specimen, isLoading: specimenLoading } = useQuery(
    [`${pageTitle}specimen`, searchParams],
    getSecimen,
    {
      refetchOnWindowFocus: false,
    }
  );

  const { mutate: save, isLoading } = useMutation(saveMasterData, {
    onSuccess: (result) => {
      if (result.responseIndicator == "success") {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "success",
          duration: 3000,
        });
        handleGoBack();
      } else {
        showSnackbar({
          message: result.responseMessage,
          open: true,
          variant: "warning",
          duration: 3000,
        });
      }
    },
    onError: (e: any) => {
      showSnackbar({
        message:
          e?.response?.data?.responseMessage ||
          e?.response?.data?.errorMessage ||
          "Something went wrong !",
        open: true,
        variant: "error",
        duration: 3000,
      });
    },
  });

  const onSubmit = (value: MasterFormDataType) => {
    save({
      categoryId: data?.categoryId || null,
      categoryName: value.categoryName,
      clinicId: Number(user?.clinicId),
      cptId: value.cpt?.map((i) => i.cptId) || [],
      description: value.description,
      isActive: value.isActive ? 1 : 0,
      specimenId: value.specimen?.specimenId || null,
      subDeptId: Number(value?.subDept?.subDeptId),
    });
  };

  const handleSubDeprtmentChange = (e: any) => {
    if (e?.target?.value?.deptId) {
      console.log(e.target.value);
      setCptSearchParams((prev) => ({
        ...prev,
        filter: {
          ...prev.filter,
          // cptGrpId: e.target.value.deptId
        },
      }));
    }
    const data = form.getValues()
    form.reset({
      ...data,
      description:"",
      cpt:[],
      specimen:null
    })
  };

  const handleReset = () => {
    form.reset(initialFormData);
  };

  const handleOnDropdownClose = (_: SyntheticEvent, reason: string) => {
    setOpen(!Boolean(reason == "escape" || reason == "blur"));
  };
  const handleOnOpen = (_: SyntheticEvent) => {
    setOpen(true);
  };

  useEffect(() => {
    if (data) {
      form.reset({
        ...data,
        subDept: {
          subDeptId: data.subDeptId,
          subDeptName: data.subDeptName,
        },
        specimen: {
          specimenId: data.specimenId || 1,
          specimenName: String(data.specimenName || ""),
        },
      });
    }
  }, [data]);

  return (
    <div className="p-3">
      <form onSubmit={form.handleSubmit(onSubmit)}>
        <Paper>
          <div className="flex justify-between items-center p-2">
            <div>
              <Typography variant="h6" className="p-3">
                {data ? "Update" : "Add"} {pageTitle}
              </Typography>
            </div>
            <div className="flex gap-2">
              <Button
                disabled={isLoading}
                variant="outlined"
                startIcon={<ArrowBackIcon />}
                onClick={handleGoBack}
              >
                back
              </Button>
              {!Boolean(data) && (
                <Button
                  disabled={isLoading}
                  color="error"
                  type="reset"
                  onClick={handleReset}
                  startIcon={<CloseIcon />}
                >
                  reset
                </Button>
              )}
              <Button
                disabled={isLoading}
                type="submit"
                color="success"
                startIcon={
                  isLoading ? (
                    <CircularProgress size={20} color="success" />
                  ) : (
                    <SaveIcon />
                  )
                }
              >
                {data ? "update" : "save"}
              </Button>
            </div>
          </div>
          <Divider />
          <div className="p-3 grid grid-cols-4 gap-3">
            <CustomFormField
              control={form.control}
              name="categoryName"
              element="input"
              fieldProps={{ label: "Enter category name " }}
              rules={{ required: "Category name is required" }}
            />
            <CustomFormField
              control={form.control}
              options={subDepartmentList?.response || []}
              loading={departmentLoading}
              name="subDept"
              element="autocomplete"
              fieldProps={{ label: "Select sub department" }}
              rules={{
                required: "Select sub required",
                onChange: handleSubDeprtmentChange,
              }}
              autocompleteProps={{
                filterOptions: (option) => option,
                getOptionLabel: (option) => option?.subDeptName,
                isOptionEqualToValue: (option, value) =>
                  option?.subDeptId == value?.subDeptId,
                onInputChange: (_, searchText) => {
                  setSearchParams((prev) => ({ ...prev, searchText }));
                },
              }}
            />
            <div>
              <CustomFormField
                control={form.control}
                options={specimen?.response || []}
                loading={specimenLoading}
                name="specimen"
                element="autocomplete"
                fieldProps={{ label: "Specimen" }}
                rules={{
                  required: false,
                  // onChange: handleSubDeprtmentChange,
                }}
                autocompleteProps={{
                  getOptionLabel: (option) => option?.specimenName,
                  isOptionEqualToValue: (option, value) =>
                    option?.specimenId == value?.specimenId,
                }}
              />
            </div>

            <CustomFormField
              control={form.control}
              element="input"
              name="description"
              fieldProps={{ label: "Description " }}
              rules={{ required: "Description required" }}
            />
            <CustomFormField
              control={form.control}
              name="isActive"
              element="radio"
              radioProps={{ row: true }}
              radios={[
                { label: "Active", value: 1 },
                { label: "Inactive", value: 0 },
              ]}
              fieldProps={{ label: "Status " }}
              rules={{ required: "Status is required" }}
            />

            <div className="col-span-full">
              <CustomFormField
                control={form.control}
                name="cpt"
                element="autocomplete"
                loading={cptsLoading}
                fieldProps={{ label: "Enter CPT name " }}
                options={cpts?.response?.items || []}
                autocompleteProps={{
                  open,
                  onOpen: handleOnOpen,
                  onClose: handleOnDropdownClose,
                  multiple: true,
                  getOptionLabel: (option) =>
                    `( ${option?.cptCode} ) ${option?.cptName}`,
                  isOptionEqualToValue: (option, value) =>
                    option?.cptId == value?.cptId,
                  onInputChange: (_, searchText) => {
                    setCptSearchParams((prev) => ({
                      ...prev,
                      filter: { ...prev.filter, searchText },
                    }));
                  },
                  filterOptions: (option) => option,
                }}
                rules={{
                  required: "CPT required",
                  onChange: (value) => {
                    console.log(value);
                  },
                }}
              />
            </div>
          </div>
        </Paper>
      </form>
    </div>
  );
}

export default AddOrSubDepartment;
